import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store/store";
import Vuebar from "vuebar";
import "./plugins/base";
import VueSkycons from "vue-skycons";
import InstantSearch from "vue-instantsearch";
import firebase from 'firebase/app'
import 'firebase/firestore';

//ถ้าทำอยู่ใน project เดียวกันไม่ต้องทำแยก 2 config
const config_skmfarm = {
  apiKey: 'AIzaSyCxrOk03GstwCDpxmoWqi9ApWvSs2gMBOc', //YOUR_PROJECT_API_KEY
  authDomain: 'skmfarm-cc5cc.firebaseapp.com',
  databaseURL: 'https://skmfarm-cc5cc.firebaseio.com',
  projectId: 'skmfarm-cc5cc', //YOUR_PROJECT_ID
  storageBucket: 'skmfarm-cc5cc.appspot.com',
  messagingSenderId: '1034285450280' //YOUR_SENDER_ID
};
const config2_Farm1 = {
  apiKey: 'AIzaSyA8Uk9gsjMn9V9WuDrjWEH9QN9DeDIayc8', //YOUR_PROJECT_API_KEY
  authDomain: 'admin-7d97b.firebaseapp.com',
  databaseURL: 'https://admin-7d97b.firebaseio.com',
  projectId: 'admin-7d97b', //YOUR_PROJECT_ID
  storageBucket: 'admin-7d97b.appspot.com',
  messagingSenderId: '998322986525' //YOUR_SENDER_ID
};
//ตัวอย่าง 2 project ที่เอา auth จาก project ที่1 และ firestore จาก project ที่2
firebase.initializeApp(config2_Farm1)//ใช้กับ config ที่จะ login
var otherProject = firebase.initializeApp(config_skmfarm, 'other');
export const db = otherProject.firestore(); //firestore จาก config ตัวที่ 2
export const db2 = firebase.firestore(); // firestore จาก config ตัวที่ 1

Vue.use(VueSkycons, {
  color: "#1e88e5",
});
Vue.use(InstantSearch);
Vue.config.productionTip = false;
Vue.use(Vuebar);

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
